import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-webhook-header',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatTooltipModule],
  templateUrl: './webhook-header.component.html',
  styleUrl: './webhook-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebhookHeaderComponent {
  headerGroup = input.required<FormGroup>();
  valueInputType = input<'text' | 'password'>('text');
  valuePlaceholder = input<string>('Header value');

  remove = output<void>();

  get nameControl() {
    return this.headerGroup().get('name');
  }

  get valueControl() {
    return this.headerGroup().get('value');
  }

  get isNameInvalid(): boolean {
    const control = this.nameControl;
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  get isValueInvalid(): boolean {
    const control = this.valueControl;
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  onRemove(): void {
    this.remove.emit();
  }
}
